export enum RecorrenciaPlanoAssinaturaEnum {
  MENSAL = 1,
  ANUAL = 12,
}
